import { render, staticRenderFns } from "./CardListItem.vue?vue&type=template&id=2739971f&scoped=true&"
import script from "./CardListItem.vue?vue&type=script&lang=ts&"
export * from "./CardListItem.vue?vue&type=script&lang=ts&"
import style0 from "./CardListItem.vue?vue&type=style&index=0&id=2739971f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2739971f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
